angular.module('tenantManuscriptPreviewModule', []).controller('tenantManuscriptPreviewCtrl', [
    '$scope',
    'trsHttpService',
    '$stateParams',
    '$state',
    'localStorageService',
    'modalDialog',
    'resCtrModalService',
    'resourceCenterService',
    'storageListenerService',
    '$q',
    '$sce',
    'previewService',
    'editCenUploadVideoForXjService',
    '$compile',
    '$sessionStorage',
    function(
        $scope,
        trsHttpService,
        $stateParams,
        $state,
        localStorageService,
        modalDialog,
        resCtrModalService,
        resourceCenterService,
        storageListenerService,
        $q,
        $sce,
        previewService,
        editCenUploadVideoForXjService,
        $compile,
        $sessionStorage
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.headPic = '';
            $scope.detailInfos = '';
            $scope.status = {
                source: $stateParams.source,
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: true, // 作者信息
                    videosInfo: true, // 视频信息
                    keywordInfo: true, // 关键字
                    abstractInfo: true, // 摘要
                    remarksInfo: true, // 备注
                    mcnInfo: true, // mcn/ugc信息
                },
                listOpen: 'processView',
            };
            $scope.videoUrl = 'https://testmeizi01.tmuyun.com/pu1558937629661xianchang_1558923226915_shadow.mp4';
            $scope.data = {
                groupProcess: {
                    medias: [],
                    selectedMedia: '',
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                },
            };
        }

        function initData() {
            headPortrait();
            getDetail();
            queryOperMedias().then(function() {
                getQqjccInfo();
            });
            $scope.videoUrl = $sce.trustAsResourceUrl($scope.videoUrl);
            // getQqjccInfo();
        }

        /**
     * [headPortrait description] 获取头像
     * @return {[type]} [description]
     */
        function headPortrait() {
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }

        /**
     * [highestMedia description：头部- 退出登录]
     */
        $scope.logout = function() {
            // localStorageService.remove('currLoginUser'); // session改变
            $sessionStorage.remove('currLoginUser');
            // localStorageService.remove('mlfCachedUser'); // session改变
            $sessionStorage.remove('mlfCachedUser');
            $('#unreadPrompt_js').hide(); // 关闭传稿提示框
            $.ajax({
                url: '/wcm/logout.jsp',
                method: 'get',
                async: false,
                success: function() {},
                error: function() {},
            });
            $state.go('front.editctr.iWo.personalManuscript', {}, { reload: true });
        };

        /**
     * [getDetail 获取详情]
     * @return {[type]} [description]
     */
        function getDetail() {
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'info',
                dataId: $stateParams.dataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                // data.HTMLCONTENT = data.CONTENT.replace(/\n/g, "<br/>").replace(/ /g, "&nbsp;");
                $scope.detailInfos = data.data;
                $scope.detailInfos.DOCTYPEID = $scope.detailInfos.type;
                // $scope.detailInfos.URL = data.data.link;
                $scope.detailInfos.METADATAID = $scope.detailInfos.srcId;
                // $scope.detailInfos.link = $sce.trustAsResourceUrl($scope.detailInfos.link);
                // getVideoUrl($scope.detailInfos.videoList);
                if ($scope.detailInfos.type == 2) {
                    // $scope.detailInfos.picList = JSON.parse($scope.detailInfos.picList);
                    angular.forEach($scope.detailInfos.picList, function(item) {
                        item.PERPICURL = item.appfile;
                        item.APPDESC = item.appdesc;
                    });
                } else if ($scope.detailInfos.type == 7) {
                    editCenUploadVideoForXjService.getVideoMark({ AUDIOVIDEOID: $scope.detailInfos.videoList }).then(function(data) {
                        $scope.detailInfos.link = $sce.trustAsResourceUrl(data.videoUrl); // 回填URL
                        $scope.detailInfos.URL = data.videoUrl;
                    });
                }
            });
        }

        // /**
        //  * [getVideoUrl description]  获取视频链接
        //  * @return {[type]} [description]
        //  */
        // function getVideoUrl(videId) {
        //     previewService.getAudioVideoPlayer(videId, 'video/mp4').then(function(item) {
        //         $scope.videos = {
        //             type: "video",
        //             id: videId,
        //             info: "",
        //             src: $sce.trustAsResourceUrl(item.DATA.videoUrl),
        //             filename: item.DATA.filename
        //         };
        //     });
        // }
        /**
     * [pageTurning description] 翻页 上一篇/下一篇
     * @param {int} direction [description]
     * @return {[type]} [description]
     */
        $scope.pageTurning = function(direction) {
            // 88
            var pageTurningData;
            pageTurningData = JSON.parse(localStorageService.get('tenantManuscriptPreview'));
            var metadataid = $stateParams.dataid;
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].id == metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                dataid: toPageData.id,
                source: $stateParams.source,
            }, {
                reload: true
            });
        };

        /**
     * [fetchManuscript 取稿]
     * @return {[type]} [description]
     */
        $scope.fetchManuscript = function() {
            if ($scope.detailInfos.status === 1) {
                modalDialog.alertType('', '该稿件已被撤稿，无法取稿', 'warning', 'confirm');
                return;
            }
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'takeArticle',
                dataIds: $stateParams.dataid,
                // SourceName: '资源中心-租户间稿库'
            };
            // var detailData = {}
            var modalInstance = resCtrModalService.fullTakeDraft(params, true, [$scope.detailInfos], undefined, false);
            modalInstance.result.then(
                function() {
                    storageListenerService.addListenerToResource('takeDraft');
                    // initOperFlag($scope.data.selectedArray);
                    // getDraftRecord($scope.data.selectedArray);
                    // $scope.data.selectedArray = [];
                },
                function() {
                    // initOperFlag($scope.data.selectedArray);
                    // getDraftRecord($scope.data.selectedArray);
                    // $scope.data.selectedArray = [];
                }
            );
        };

        /**
     * [collect 收藏]
     * @return {[type]} [description]
     */
        $scope.collect = function() {
            var ids = $stateParams.dataid;
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'collectShareDoc',
                dataIds: ids,
            };
            resourceCenterService.collectDocs(params).then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
                // $scope.data.selectedArray = [];
            });
        };

        /**
     * [CreationAxis 个人素材]
     */
        $scope.CreationAxis = function() {
            // if (!$scope.data.selectedArray.length) {
            //     modalDialog.alertType("请先选择稿件！", "", "warning", false, "");
            //     return;
            // }
            // for (var i = 0; i < $scope.data.selectedArray.length; i++) {
            if ($scope.detailInfos.type > 2) {
                modalDialog.alertType('只能添加新闻和图集!', '', 'error', false, '');
                return;
            }
            // }
            var ids = $stateParams.dataid;
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'addPersonalMaterialFromShare',
                dataIds: ids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.message) {
                    modalDialog.alertType('', data.message, 'error', false, function() {
                        // $scope.data.selectedArray = [];
                    });
                } else {
                    modalDialog.alertType('添加成功!', '', 'success', false, function() {
                        // $scope.data.selectedArray = [];
                    });
                }
            });
        };

        /**
     * [getQqjccInfo 获取操作记录]
     * @return {[type]} [description]
     */
        function getQqjccInfo(item) {
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'queryFlagList',
                dataId: $stateParams.dataid,
            };
            if (angular.isDefined(item)) {
                if (item.MEDIANAME != '全部') {
                    params.mediaid = item.MEDIAID;
                    params.mediatype = item.MEDIATYPE;
                }
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.groupProcess.process = data.OPERS;
            });
        }

        /**
     * [queryOperMedias 查询稿件取稿到-渠道]
     * @return {[type]} [description]
     */
        function queryOperMedias() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'queryOperMediasList',
                dataId: $stateParams.dataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.groupProcess.medias = [
                    {
                        MEDIANAME: '全部',
                        MEDIATYPE: '',
                        MEDIAID: '',
                    },
                ].concat(data);
                $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
                defer.resolve();
            });
            return defer.promise;
        }

        /**
     * [selectQqjccChannel 切换流程]
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
        $scope.selectQqjccChannel = function(item) {
            $scope.data.groupProcess.selectedMedia = item;
            getQqjccInfo(item);
        };
    },
]);
